function initEguideFilter() {
 
	var $input, $me, settings, results, searchedVal = null, delay = null, searchData, onHandlers, privateFn;
	
	// Private functions
	privateFn = {
		filter: function(force){
			if(searchedVal !== $input.val().toLowerCase() || force === true){
				searchedVal = $input.val().toLowerCase();
				clearTimeout(delay);
				delay = setTimeout(function(){
					
					results = [];
					var htmlResult = [];
					
					// Filter result list
					if(searchedVal.length >= settings.minChar){
						$.each(searchData, function(){
							
							var pos = null,
								hilightedString = null;
							
							if((pos = this[settings.dataTestProperty].toLowerCase().indexOf(searchedVal))!== -1){
								results.push({
									hilightedString: this[settings.dataTestProperty].substring(0, pos) + '<em>' + this[settings.dataTestProperty].substring(pos, pos + searchedVal.length) + '</em>' + this[settings.dataTestProperty].substring(pos + searchedVal.length),
									entryData:this
								});
							}
						})
					}
					
					// Trigger onFiltered handler
					if(typeof onHandlers.filtered === 'function'){
						onHandlers.filtered(results);
					}
					
					// Generate result list
					if(results.length > 0){
						$.each(results, function(){
							htmlResult.push('<li>' + this.hilightedString + '</li>');
						})
					}

					// Display
					$me.html('<ul>' + htmlResult.join('') + '</ul>');
						
				}, settings.minCaptionDelay);
			}
		},
		
		init: function(){
			// Init handling click on result list entries
			$me.on('click', 'li', function(){
			
				// Push the value selected in result list into input field
				$input.val(results[$me.find('li').index(this)].entryData[settings.dataTestProperty]);
				
				// Trigger onResultClick
				if(typeof onHandlers.resultClick === 'function'){
					onHandlers.resultClick(results[$me.find('li').index(this)].entryData);
				}
				
			});
			
			// Init handling rollover on result list entries
			$me.on('mouseenter', 'li', function(){
				$(this).parent().find('li.' + settings.selectedResultLineClass).removeClass(settings.selectedResultLineClass);
				$(this).addClass(settings.selectedResultLineClass);
			}); 
			
			// Init stopping event propagation on handled elements
			$me.click(function(event){
				event.stopPropagation();
			});
			$input.click(function(event){
				event.stopPropagation();
			})
			
			// Init handling hotKeys 
			$input.on('keydown', privateFn.hotHeyHandle);
			
			// Init applying filtering
			$input.on('keyup', privateFn.filter);
			$input.on('click', function(){privateFn.filter(true)});
		},
		
		hotHeyHandle: function(event){
			privateFn.hotHeyUpDownHandle(event);
			privateFn.hotKeyEnterHandle(event);
		},
		
		hotKeyEnterHandle: function(event){
		
			var index = $me.find('li.selected').index(),
				value;
			
			// if Enter key pressed
			
			if(event.which === 13 && index >= 0){
			
				value = results[index].entryData[settings.dataTestProperty]
			
				event.stopPropagation();
				event.preventDefault();
				
				// Prevent filtering to be applied
				searchedVal = value.toLowerCase();
				
				// Push the value selected in result list into input field
				$input.val(value);
				
				// Trigger onResultClick
				if(typeof onHandlers.resultClick === 'function'){
					onHandlers.resultClick(results[index].entryData);
				}
			}
		},
		
		hotHeyUpDownHandle: function(event){
			
			var currentIndex = null, $selected = $me.find('li.selected'), $items = $me.find('li');
			if($selected.length > 0){
				currentIndex = $selected.index();
			}
			switch(event.which) {
			case 38: // up
				event.stopPropagation();
				event.preventDefault();
				if(currentIndex !== null){
					currentIndex--;
				} else {
					currentIndex = $items.length - 1
				}
				break;

			case 40: // down
				event.stopPropagation();
				event.preventDefault();
				if(currentIndex !== null){
					currentIndex++;
				} else {
					currentIndex = 0
				}
				break;
			default:
				return;
			}
			if(currentIndex !== null){
				if(currentIndex < 0){
					currentIndex = $items.length - 1;
				}
				
				if(currentIndex > $items.length - 1){
					currentIndex = 0;
				}
				
				$items.removeClass(settings.selectedResultLineClass);
				$items.eq(currentIndex).addClass(settings.selectedResultLineClass);
			}
		}
	}
	
	
    $.fn.eGuideFilter = function( arg1, arg2 ) {
		var action, options, methods, defaultSettings;
		
		$me = this
		
		defaultSettings = {
			minChar: 2,
			minCaptionDelay: 200,
			selectedResultLineClass: 'selected',
			dataTestProperty : 'title'
		};
		
		if(typeof arg1 === 'string'){
			action = arg1;
			options = arg2;
		} else {
			action = 'init';
			settings = $.extend(defaultSettings, arg1);
		}
		
		methods = {
			init: function(){
				$input = settings.input;
				searchData = settings.data || {};
				onHandlers = settings.on || {};
				privateFn.init();
			}
		}
		
		if(methods[action] !== undefined){
			methods[action]()
		} else {
			throw new Error('Unknown method "' + action + '"') ;
		}
 
		return $me;

    };
 
}